export default function createToggle(component) {
  const { toggle } = component.dataset;
  if (!component.id) {
    component.id = `toggle-${Math.random().toString(36).substring(7)}`;
  }
  component.setAttribute("aria-controls", toggle);
  toggle.split(" ").forEach((id) => {
    const node = document.getElementById(id);
    if (node) {
      node.setAttribute("aria-labelledby", [node.getAttribute("aria-labelledby"), component.id].filter(Boolean).join(" "));
    }
  });
  component.addEventListener("click", () => {
    toggle.split(" ").forEach((id) => {
      const node = document.getElementById(id);
      if (node) {
        node.hidden = !node.hidden;
        node.setAttribute("aria-expanded", !node.hidden);
      }
    });
    document.dispatchEvent(new Event("on:toggle"));
  });
  document.addEventListener("click", (event) => {
    const isDialogElement = event.target.closest("[data-dialog]");
    document.querySelectorAll('[data-toggle][aria-expanded="true"]').forEach((trigger) => {
      const dropdownElement = document.getElementById(trigger.getAttribute("aria-controls"));
      if (event.target === trigger || isDialogElement || dropdownElement && event.target.closest(`#${dropdownElement.id}`)) {
        return;
      }
      trigger.click();
    });
  }, { capture: true });
}
